<template>
    <div class="rigth_bar" v-show="false">
        <div class="header_img" @click="handleHnrInfo">
            <img :src="headerimg" alt />
        </div>
        <div class="likeheart" @click="handleLike">
            <van-icon name="like" size="1rem" color="#ffffff" />
            <span class="likeheart_text">{{ t_num }}</span>
        </div>
        <div class="info" @click="handleInfo">
            <van-icon name="chat" dot size="1rem" color="#ffffff" />
        </div>

        <van-action-sheet v-model="show_action" title="视频详情" :get-container="getContainer">
            <div class="content" style="height:8rem;">
                <div class="newsdetail_title">{{ title }}</div>

                <div class="newsdetail_content">{{ des }}</div>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { Dialog, Notify } from 'vant';
import copy from "copy-to-clipboard";

import { tranNumber } from "../util/video_article";

export default {
    props: ['headerimg', 'sharetext', 'clicknum', 'jianjielink', 'title', 'des'],
    data() {
        return {
            show_action: false,
            show_action_hnr: false,
        }
    },
    methods: {
        // 文章本身信息
        handleInfo() {
            this.show_action = true;
        },
        // 映象网的信息
        handleHnrInfo() {
            console.log("开始跳转")
            window.location.href = this.jianjielink;
        },
        handleLike() {
            Dialog.confirm({
                title: "复制下列文本打开抖音搜索",
                message: this.sharetext,
                confirmButtonText: "一键复制"
            })
                // 一键复制确认
                .then(() => {
                    // on confirm
                    copy(this.sharetext);
                    Notify({ type: 'success', message: '复制成功！' })
                })
                .catch(() => {
                    // on cancel
                });
        },
        getContainer() {
            return document.querySelector('body');
        },
    },
    computed: {

        t_num() {
            return tranNumber(+this.clicknum, 2)
        }
    }
}
</script>


<style>
.rigth_bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 1.5rem;
}

.header_img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    overflow: hidden;
}

.header_img img {
    width: 100%;
}

.likeheart {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 0.5rem;
}

.likeheart_text {
    font-size: 0.293333rem;
    text-align: center;
    color: #ffffff;
    margin-top: 0.133333rem;
}

.info {
    margin-top: 0.34rem;
}

.newsdetail_title {
    text-align: center;
    font-size: 0.6rem;
    line-height: .8rem;
    font-weight: bold;
    margin: 0 auto;
    margin-top: 0.1rem;
    width: 90%;
}

.newsdetail_content {
    font-size: 0.42rem;
    color: #333;
    line-height: 1.8;
}

.newsdetail_content,
.relate_panel {
    width: 100%;
    box-sizing: border-box;
    padding: 0.4rem;
    margin-bottom: 0.6rem;
}

.newsdetail_content * {
    max-width: 100%;
}

.newsdetail_content p {
    font-size: 22px;
    color: #333;
    line-height: 1.6;
    padding-bottom: 0.3rem;
    letter-spacing: 2px;
}

.newsdetail_content section {
    font-size: 22px;
    color: #333;
    line-height: 1.6;
    letter-spacing: 2px;
}

.newsdetail_content img {
    height: auto;
    display: block;
    margin: 0 auto;
    max-width: 100% !important;
}

.newsdetail_content video {
    margin: 0.266667rem 0;
    width: 100%;
    height: auto;
    display: block;
}

.newsdetail_content strong {
    font-weight: 700;
}

.newsdetail_content .right-wrap {
    text-align: right;
}

.newsdetail_content .right-wrap p {
    color: #9fa0a0;
    font-size: 0.52rem;
}
</style>
